import { decryptParams, decryptParamsByGCM, decryptParamsByGCM256 } from 'logic/encryptData'

export const typeDecryptParams = (flag, data) => {
  if (flag === 'GCM') {
    return decryptParamsByGCM(data)
  }
  else if (flag === 'AES_GCM_256') {
    return decryptParamsByGCM256(data)
  }
  return decryptParams(data)
}

export const getPathname = () => (window.location.pathname.split('/')[1])

export const queryParams = () => {
  return new URLSearchParams(window.location.search);
}
 
export const getDecryptParam = () => {
  const query = queryParams()
  const start = query.get("start")
  const flag = query.get("flag")?.toUpperCase()
  return typeDecryptParams(flag, start)
}
